import { ChatIntegrationName } from "./chatOpsTypes";

export function chatOpsUtils(value: any): value is ChatIntegrationName {
  return Object.values(ChatIntegrationName).includes(value);
}
